import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { ProductspageComponent } from './productspage/productspage.component';
import { RegisterComponent } from './register/register.component';
import { MenOversizedPlainComponent } from './men-oversized-plain/men-oversized-plain.component';
import { ViewProductsComponent } from './view-products/view-products.component';
import { ViewCartComponent } from './view-cart/view-cart.component';
import { LoginSignupWithOtpComponent } from './login-signup-with-otp/login-signup-with-otp.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { TermsOdServicePolicyComponent } from './terms-od-service-policy/terms-od-service-policy.component';
import { ReturnAndRefundPolicyComponent } from './return-and-refund-policy/return-and-refund-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MenOversizedPrimtedComponent } from './men-oversized-primted/men-oversized-primted.component'
import { WomenOversizedPrintedComponent } from './women-oversized-printed/women-oversized-printed.component';
import { WomenOversizedPlainComponent } from './women-oversized-plain/women-oversized-plain.component';
import { OrderComponent } from './order/order.component';
import  {PaymentComponent} from './payment/payment.component';
import  { AccountComponent } from './account/account.component';
import { AddressComponent } from './address/address.component';
import { BestsellersComponent } from './bestsellers/bestsellers.component';
import { NewArrivalsComponent } from './new-arrivals/new-arrivals.component';

const routes: Routes = [
  
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {path : 'home',component : LandingPageComponent},
  {path : 'login',component : LoginComponent},
  {path : 'other',component : ProductspageComponent},
  {path : 'register',component : RegisterComponent},
  {path : 'menplain',component : MenOversizedPlainComponent},
  {path : 'menprinted',component : MenOversizedPrimtedComponent},
  {path : 'viewProducts',component : ViewProductsComponent},
  {path : 'viewCart',component : ViewCartComponent},
  {path : 'loginWithOtp',component : LoginSignupWithOtpComponent},
  {path : 'shoppingPoilcy',component : ShippingPolicyComponent},
  {path : 'termsOfService',component : TermsOdServicePolicyComponent},
  {path : 'returnAndRefundPolicy',component : ReturnAndRefundPolicyComponent},
  {path : 'privacyPolicy',component : PrivacyPolicyComponent },
  {path : 'womenplain',component : WomenOversizedPlainComponent},
  {path : 'womenprinted',component : WomenOversizedPrintedComponent},
  {path : 'order',component : OrderComponent},
  {path : 'payment',component : PaymentComponent},
  {path : 'account',component : AccountComponent},
  {path : 'address',component : AddressComponent},
  {path : 'bestSellers',component : BestsellersComponent},
  {path : 'newArrivals',component : NewArrivalsComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
  scrollPositionRestoration: 'enabled'  // or 'top'
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
